import * as React from "react";
const SvgInactiveProfile = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-cb340f02-2014-407d-b8d2-0a36b330a3f6", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 7.75, style: {
  fill: "#fff",
  stroke: "#2f3232",
  strokeWidth: ".5px"
} }));
export default SvgInactiveProfile;
